import { render, staticRenderFns } from "./user-dropdown.vue?vue&type=template&id=380c3972&lang=html&"
import script from "./user-dropdown.vue?vue&type=script&lang=js&"
export * from "./user-dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports